function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import PropTypes from "prop-types";
import React, { Component } from "react";
import classnames from "classnames";
import Button from "../Button/Button";
import Cloak from "../Cloak/Cloak";
import ProgressInfinite from "./ProgressInfinite";
import "./ProgressButton.css";
const progressSizeMap = {
  small: "1rem",
  medium: "1.25rem",
  large: "1.5rem"
};
const progressColorMap = {
  primary: "white",
  secondary: "subtle"
};
export default class ProgressButton extends Component {
  render() {
    const {
      children,
      isInProgress,
      size = "medium",
      variant = "primary",
      ...rest
    } = this.props;
    const classes = classnames("ax-progress-button", {
      "ax-progress-button--in-progress": isInProgress
    });
    return /*#__PURE__*/React.createElement(Button, _extends({}, rest, {
      active: isInProgress,
      size: size,
      variant: variant
    }), /*#__PURE__*/React.createElement("div", {
      className: classes
    }, /*#__PURE__*/React.createElement(Cloak, {
      className: "ax-progress-button__content",
      invisible: isInProgress
    }, children), /*#__PURE__*/React.createElement(Cloak, {
      className: "ax-progress-button__indicator",
      invisible: !isInProgress
    }, /*#__PURE__*/React.createElement(ProgressInfinite, {
      color: progressColorMap[variant],
      sizeRem: progressSizeMap[size]
    }))));
  }

}